import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";

const PendingPaymentModal = ({ visible, onHide, pendingPayment, formatCurrency, formatDate }) => {
    const navigate = useNavigate();


    const formatPaymentMethod = (method) => {
        const methodMap = {
            'cash': 'Cash',
            'cheque': 'Cheque',
            'bank-transfer': 'Bank Transfer'
        };
        return methodMap[method] || method?.charAt(0).toUpperCase() + method?.slice(1) || 'N/A';
    };

    const footer = (
        <div className="d-flex justify-content-end gap-2">
            <Button
                label="Cancel"
                onClick={onHide}
                className="p-button-text btn btn-secondary"
            />
            {/* <Button
                label="Go to Payments"
                icon="pi pi-arrow-right"
                onClick={handleGoToPayments}
                className="btn btn-primary"
            /> */}
        </div>
    );

    return (
        <Dialog
            header={
                <div className="d-flex align-items-center">
                    <i className="fas fa-exclamation-triangle text-warning me-2" style={{ fontSize: '1.5rem' }}></i>
                    <span>Pending Payment Exists</span>
                </div>
            }
            visible={visible}
            onHide={onHide}
            footer={footer}
            style={{ width: '600px' }}
            modal
            draggable={false}
        >
            <div className="p-3">
                <div className="alert alert-warning mb-4" role="alert">
                    <i className="fas fa-info-circle me-2"></i>
                    A manual payment for this invoice is already pending approval. Please approve or reject the existing payment before creating a new one.
                </div>

                {pendingPayment && (
                    <div className="card">
                        <div className="card-body">
                            <h6 className="card-title mb-3">Pending Payment Details</h6>
                            
                            <div className="row mb-2">
                                <div className="col-6">
                                    <strong>Payment Reference:</strong>
                                </div>
                                <div className="col-6">
                                    {pendingPayment.paymentReference || 'N/A'}
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-6">
                                    <strong>Receipt Number:</strong>
                                </div>
                                <div className="col-6">
                                    {pendingPayment.receiptNumber || 'N/A'}
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-6">
                                    <strong>Payment Amount:</strong>
                                </div>
                                <div className="col-6">
                                    <span className="badge bg-primary">
                                        {formatCurrency ? 
                                            formatCurrency(pendingPayment.paymentAmount, pendingPayment.currency?.code) : 
                                            `${pendingPayment.currency?.code || 'KES'} ${pendingPayment.paymentAmount?.toLocaleString()}`
                                        }
                                    </span>
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-6">
                                    <strong>Payment Method:</strong>
                                </div>
                                <div className="col-6">
                                    {formatPaymentMethod(pendingPayment.paymentMethod)}
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-6">
                                    <strong>Payment Date:</strong>
                                </div>
                                <div className="col-6">
                                    {formatDate ? 
                                        formatDate(pendingPayment.paymentDate) : 
                                        new Date(pendingPayment.paymentDate).toLocaleDateString()
                                    }
                                </div>
                            </div>

                            <div className="row mb-2">
                                <div className="col-6">
                                    <strong>Created At:</strong>
                                </div>
                                <div className="col-6">
                                    {formatDate ? 
                                        formatDate(pendingPayment.createdAt) : 
                                        new Date(pendingPayment.createdAt).toLocaleDateString()
                                    }
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <strong>Status:</strong>
                                </div>
                                <div className="col-6">
                                    <span className="badge bg-warning text-dark">
                                        {pendingPayment.approvalStatus}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Dialog>
    );
};

export default PendingPaymentModal;